import React, { Fragment } from 'react'

import { detect } from 'detect-browser'
import { getDroppedOrSelectedFiles } from 'html5-file-selector'
import update from 'immutability-helper'
import JSZip from 'jszip'
import Dropzone from 'react-dropzone'

import axios from 'axios'
import Cookies from 'js-cookie'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'

import { debounce } from 'throttle-debounce'

import { restrictedTags, prohibitedSoftwareTags, ignoredTags } from 'Pods/Shared/Constants/tagDenylists'
import DropzoneOverlay from 'Pods/Shared/DropzoneOverlay'
import Icon from 'Pods/Shared/Icon/Icon'
import Loader from 'Pods/Shared/Loader'
import { run, RuleRunner } from 'Pods/Shared/RuleRunner'
import * as ValidationRules from 'Pods/Shared/Rules/Rules'
import StickyFooterActions from 'Pods/Shared/StickyFooterActions'
import fileChecksum from 'Utils/fileChecksum'

import CategoryArea from './CategoryArea'
import ChallengesArea from './ChallengesArea'
import { MULTIPLE_PARTS_DEFAULTS } from './constants'
import DetailsArea from './DetailsArea'
import EmbedsArea from './Embeds/EmbedsArea'
import { hasSupportedFileTypesForViewer } from '../../shared/utils/fileTypeUtils'
import FilesArea from './Files/FilesArea'
import DirectUploadImages from './Images/DirectUploadImages'
import ImagesArea from './Images/ImagesArea'
import DeleteConfirmationModal from './Modals/DeleteConfirmationModal'
import PricingAndLicenseArea from './PricingAndLicenseArea'
import PublishingScore from './PublishingScore/PublishingScore'
import TechnicalDetailsArea from './TechnicalDetails/TechnicalDetailsArea'
import UploadArea from './UploadArea'
import UploadProgress from './UploadProgress'
import KodamaNotice from '../../Listing/Components/KodamaNotice'

class ModelPublisher extends React.Component {
  constructor() {
    super()

    this.state = {
      isDataFetched: false,
      itemLink: '',
      attachments: {},
      disableActions: false,
      confirmationModalIsOpen: false,
      dropzoneActive: false,
      disableDropZone: false,
      uploadsInProgress: 0,
      fileTypes: [],
      categories: [],
      id: '',
      status: 'draft',
      type: 'cg',
      publishingScore: 0,
      isAdultContent: false,
      categoryId: null,
      subcategoryId: null,
      isImageUploadMode: false,
      techDetails: {
        cg: {
          textures: false,
          materials: false,
          animated: false,
          rigged: false,
          gameReady: false,
          pbr: false,
          uvwMapping: false,
          pluginsUsed: false,
          unwrappedUvs: null,
          geometryType: null,
          polygons: '',
          vertices: '',
        },
        printable: {
          units: null,
          isPreSupported: false,
          isSplitIntoMultipleParts: false,
          multiplePartsDetails: MULTIPLE_PARTS_DEFAULTS,
        },
        cad: {},
      },
      showErrors: false,
      descriptionHasError: false,
      tagHasError: false,
      title: '',
      description: '',
      tags: [],
      price: 0,
      isFree: false,
      aiGenerated: false,
      license: 'royalty_free',
      customLicense: '',
      otherDraftsCount: 0,
      files: [],
      images: [],
      removedImageIds: [],
      embeds: [],
      challenges: [],
      requiresForcedSave: false,
      imagesToUpload: [],
      droppedImages: [],
      sortVersion: 0,
      userData: {},
      kodamaNoticeClosed: JSON.parse(Cookies.get('kodama_notice_set') || false),
      useAsTemplate: false,
      paymentAgreementBlocker: {
        isOpen: false,
        message: '',
        ctaLabel: '',
        dismissLabel: '',
        ctaHref: '/profile/payment_agreements',
        showCta: true,
      },
    }

    this.tagsInputRef = React.createRef()
    this.imagesExtensions = ['png', 'jpg', 'jpeg']
    this.maxImageSize = 15000000

    this.fetchUserData = this.fetchUserData.bind(this)
    this.onFetchUserDataSuccess = this.onFetchUserDataSuccess.bind(this)
    this.fetchItemData = this.fetchItemData.bind(this)
    this.onFetchItemDataSuccess = this.onFetchItemDataSuccess.bind(this)
    this.onAllDataSet = this.onAllDataSet.bind(this)
    this.setFormValidations = this.setFormValidations.bind(this)
    this.setTechDetailsValidations = this.setTechDetailsValidations.bind(this)
    this.validateAndUpdateState = this.validateAndUpdateState.bind(this)
    this.updateItem = this.updateItem.bind(this)
    this.onUpdateSuccess = this.onUpdateSuccess.bind(this)
    this.updateMultipleTechDetails = this.updateMultipleTechDetails.bind(this)
    this.publishItem = this.publishItem.bind(this)
    this.onPublishSuccess = this.onPublishSuccess.bind(this)
    this.onPublishFailure = this.onPublishFailure.bind(this)
    this.onModalClose = this.onModalClose.bind(this)
    this.onDrop = this.onDrop.bind(this)
    this.handleFormSubmit = this.handleFormSubmit.bind(this)
    this.onDeleteDraftClick = this.onDeleteDraftClick.bind(this)
    this.handleDetailChange = this.handleDetailChange.bind(this)
    this.updateTechDetails = this.updateTechDetails.bind(this)
    this.checkMqsValidity = this.checkMqsValidity.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleInputBlur = this.handleInputBlur.bind(this)
    this.handleEditorChange = this.handleEditorChange.bind(this)
    this.handlePreview = this.handlePreview.bind(this)
    this.onTagsChange = this.onTagsChange.bind(this)
    this.errorFor = this.errorFor.bind(this)
    this.onTypeChange = this.onTypeChange.bind(this)
    this.onFreeModelTrigger = this.onFreeModelTrigger.bind(this)
    this.onAiGeneratedToggle = this.onAiGeneratedToggle.bind(this)
    this.checkIfFormIsValid = this.checkIfFormIsValid.bind(this)
    this.onChooseDraftModel = this.onChooseDraftModel.bind(this)
    this.addEmbed = this.addEmbed.bind(this)
    this.deleteEmbed = this.deleteEmbed.bind(this)
    this.onEmbedsChange = this.onEmbedsChange.bind(this)
    this.onViewerGenerated = this.onViewerGenerated.bind(this)
    this.onImageUploadFinish = this.onImageUploadFinish.bind(this)
    this.onUploadFailure = this.onUploadFailure.bind(this)
    this.uploadToS3 = this.uploadToS3.bind(this)
    this.onS3FileUpload = this.onS3FileUpload.bind(this)
    this.onUploadProgress = this.onUploadProgress.bind(this)
    this.fetchPublishingScore = this.fetchPublishingScore.bind(this)

    this.onFilesChange = this.onFilesChange.bind(this)
    this.onImagesChange = this.onImagesChange.bind(this)
    this.updateImageAdultAttr = this.updateImageAdultAttr.bind(this)
    this.renderPublishingScore = this.renderPublishingScore.bind(this)
    this.disableMainDropZone = this.disableMainDropZone.bind(this)
    this.adjustAttachments = this.adjustAttachments.bind(this)
    this.getSimilarityScoreTags = this.getSimilarityScoreTags.bind(this)
    this.readZipContent = this.readZipContent.bind(this)
    this.resetAdultImages = this.resetAdultImages.bind(this)
    this.setAdultImages = this.setAdultImages.bind(this)
    this.putImage = this.putImage.bind(this)
    this.handleCloseNotice = this.handleCloseNotice.bind(this)
    this.getTrackingData = this.getTrackingData.bind(this)
    this.getCurrentFileTypes = this.getCurrentFileTypes.bind(this)
    this.parsePrice = this.parsePrice.bind(this)
    this.onUseAsTemplateChange = this.onUseAsTemplateChange.bind(this)
    this.uploadAreaRef = React.createRef()
    this.handleImageUploadClick = this.handleImageUploadClick.bind(this)
    this.handleFileDialogClose = this.handleFileDialogClose.bind(this)
  }

  componentWillMount() {
    const errors = run(this.state, this.setFormValidations(this.state))
    const techDetailsErrors = run(
      this.state.techDetails.cg,
      this.setTechDetailsValidations(this.state)
    )

    this.setState({ validationErrors: { ...errors, ...techDetailsErrors } })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isEditingMode && prevProps.modelId !== this.props.modelId) {
      this.fetchItemData(this.props.modelId)
    }
  }

  componentDidMount() {
    if (!this.props.isEditingMode) {
      this.fetchItemData()
      this.fetchUserData()
    }

    let counter = 0

    window.addEventListener('dragenter', () => {
      this.setState({ dropzoneActive: true })
      counter++
    })

    window.addEventListener('dragleave', () => {
      counter--
      if (counter === 0) {
        this.setState({ dropzoneActive: false })
      }
    })

    window.addEventListener('drop', () => {
      counter = 0
      this.setState({ dropzoneActive: false })
    })

  }

  handleImageUploadClick(e) {
    e.preventDefault()
    this.setState({ isImageUploadMode: true }, () => {
      if (this.uploadAreaRef.current) {
        this.uploadAreaRef.current.openFileDialog()
      }
    })
  }

  handleFileDialogClose() {
    this.setState({ isImageUploadMode: false })
  }

  setFormValidations(state) {
    const minPriceByType = 2

    return [
      RuleRunner(
        'title',
        'Title',
        ValidationRules.required,
        ValidationRules.isAlphanumeric,
        ValidationRules.validateCompetitors,
        ValidationRules.minLength(5),
        ValidationRules.maxLength(64)
      ),
      RuleRunner(
        'description',
        'Description',
        ValidationRules.required,
        ValidationRules.validateCompetitors,
        ValidationRules.minLength(5),
        ValidationRules.maxLength(10000),
        ValidationRules.noEmoji
      ),
      RuleRunner(
        'price',
        'Price',
        state.isFree ? null : ValidationRules.min(minPriceByType),
        ValidationRules.max(15000),
        ValidationRules.decimalPrice
      ),
      RuleRunner(
        'customLicense',
        'Custom license',
        ['custom', 'custom_no_ai'].includes(state.license)
          ? ValidationRules.required
          : null,
        ValidationRules.onlyLatinSymbolsWithNewLine,
        ValidationRules.maxLength(10000),
        ValidationRules.validateCompetitors
      ),
      RuleRunner(
        'tags',
        'tags',
        ValidationRules.minArrLength(5),
        ValidationRules.maxArrLength(20)
      ),
    ]
  }

  setTechDetailsValidations(state) {
    const polygonsMinRule =
      state.type === 'cg' && state.techDetails.cg.polygons !== ''
        ? ValidationRules.min(0)
        : null
    const verticesMinRule =
      state.type === 'cg' && state.techDetails.cg.vertices !== ''
        ? ValidationRules.min(0)
        : null

    return [
      RuleRunner(
        'polygons',
        'Polygons',
        polygonsMinRule,
        ValidationRules.isNumeric,
        ValidationRules.isLimitedInteger,
        ValidationRules.isLimitedLength
      ),
      RuleRunner(
        'vertices',
        'Vertices',
        verticesMinRule,
        ValidationRules.isNumeric,
        ValidationRules.isLimitedInteger,
        ValidationRules.isLimitedLength
      ),
    ]
  }

  fetchUserData() {
    axios
      .get('/api/internal/users/me')
      .then(this.onFetchUserDataSuccess)
      .catch((error) =>
        App.events.publish('app:notification:flash:error', error.message)
      )
  }

  onFetchUserDataSuccess(response) {
    const currentState = this.state
    const responseData = response.data

    if (!responseData) return
    const {
      attributes: { username, lastIpAddress },
    } = responseData.data || { attributes: {} }
    currentState.userData = { username, lastIpAddress }

    this.setState({ currentState })
  }

  fetchItemData(id = '') {
    this.setState({ isDataFetched: false })

    const url = `/api/internal/items/${
      id === '' ? 'current-draft' : id
    }?nocache=${new Date().getTime()}`

    axios
      .get(url)
      .then(this.onFetchItemDataSuccess)
      .catch((error) =>
        App.events.publish('app:notification:flash:error', error.message)
      )
  }

  onFetchItemDataSuccess(response) {
    const attributes = response.data.data.attributes
    const included = response.data.included || []
    const itemImages =
      included.filter((item) => item.type === 'itemImages') || []
    const itemFiles = included.filter((item) => item.type === 'itemFiles') || []
    const itemFileInfos =
      included.filter((item) => item.type === 'itemFileInfos') || []
    const itemEmbeds =
      included.filter((item) => item.type === 'itemEmbeds') || []
    const currentState = this.state

    currentState.itemLink = attributes.itemLink
    currentState.fileTypes = response.data.meta.fileTypes || []
    currentState.otherDraftsCount = response.data.meta.otherDraftsCount
    currentState.categories = response.data.meta.categories || []
    currentState.challenges = response.data.meta.challenges || []
    currentState.id = response.data.data.id
    currentState.status = attributes.status
    currentState.isAdultContent = attributes.adultContent
    currentState.categoryId = attributes.categoryId
      ? attributes.categoryId
      : null
    currentState.subcategoryId = attributes.subcategoryId
      ? attributes.subcategoryId
      : null
    // attributes.price === 0
    currentState.isFree = attributes.isFree
    currentState.aiGenerated = attributes.aiGenerated
    currentState.useAsTemplate = attributes.useAsTemplate
    currentState.publishingScore = attributes.publishingScore
      ? attributes.publishingScore
      : 0
    currentState.title = attributes.title
    currentState.description = attributes.description
      ? attributes.description
      : ''
    currentState.initialDescription = currentState.description
    currentState.tags = attributes.tags
    currentState.price = attributes.price
    currentState.license = attributes.license
    currentState.customLicense = attributes.customLicense
      ? attributes.customLicense
      : ''
    currentState.parentalLocked =
      attributes.approveStatus === 'approved:parental_lock'

    if (attributes.printReady) {
      currentState.type = 'printable'
      currentState.techDetails.printable.units = attributes.units
      currentState.techDetails.printable.isPreSupported = attributes.isPreSupported ?? false
      currentState.techDetails.printable.isSplitIntoMultipleParts = attributes.isSplitIntoMultipleParts ?? false

      const rawMultiplePartsDetails = attributes.multiplePartsDetails ?? {}

      currentState.techDetails.printable.multiplePartsDetails = {
        ...MULTIPLE_PARTS_DEFAULTS,
        numberOfParts:
          rawMultiplePartsDetails.numberOfParts
          ?? MULTIPLE_PARTS_DEFAULTS.numberOfParts,
        unit:
          rawMultiplePartsDetails.unit
          ?? MULTIPLE_PARTS_DEFAULTS.unit,
        width:
          rawMultiplePartsDetails.width
          ?? MULTIPLE_PARTS_DEFAULTS.width,
        depth:
          rawMultiplePartsDetails.depth
          ?? MULTIPLE_PARTS_DEFAULTS.depth,
        height:
          rawMultiplePartsDetails.height
          ?? MULTIPLE_PARTS_DEFAULTS.height,
        assemblyInstructions:
          rawMultiplePartsDetails.assemblyInstructions
          ?? MULTIPLE_PARTS_DEFAULTS.assemblyInstructions,
      }
    } else if (attributes.productType === 'cad') {
      currentState.type = 'cad'
    } else {
      const techDetails = [
        'textures',
        'materials',
        'animated',
        'rigged',
        'gameReady',
        'pbr',
        'uvwMapping',
        'pluginsUsed',
      ]

      currentState.type = 'cg'

      techDetails.forEach((detail) => {
        currentState.techDetails.cg[detail] = attributes[detail]
          ? attributes[detail]
          : false
      })

      currentState.techDetails.cg.unwrappedUvs = attributes.unwrappedUvs
      currentState.techDetails.cg.geometryType = attributes.geometryType
      currentState.techDetails.cg.polygons = attributes.polygons
        ? attributes.polygons
        : ''
      currentState.techDetails.cg.vertices = attributes.vertices
        ? attributes.vertices
        : ''
    }

    currentState.images = itemImages.map((image) => ({
      id: image.id,
      url: image.attributes.largeUrl,
      isAdultContent: image.attributes.adultContent,
      fileName: image.attributes.fileName,
    }))

    currentState.files = itemFiles
      .map((file) => {
        const currentFileInfos = file.relationships.itemFileInfos.data
        const fileInfos = []

        if (currentFileInfos.length > 0) {
          currentFileInfos.forEach((fileInfo) => {
            fileInfos.push(
              itemFileInfos.find((info) => info.id === fileInfo.id)
            )
          })
        }

        return {
          id: file.id,
          name: file.attributes.fileName,
          archive: file.attributes.archive,
          processed: file.attributes.processed,
          autoGenerated: file.attributes.autoGenerated,
          itemFileInfos: fileInfos,
          contents: [],
        }
      })
      .filter((file) => file.name)

    currentState.embeds = itemEmbeds.map((embed) => ({
      id: Number(embed.id),
      image: embed.attributes.image,
      title: embed.attributes.title,
      position: embed.attributes.position,
      type: embed.attributes.type,
      externalId: embed.attributes.externalId,
    }))

    const updateItem = false

    const errors = run(this.state, this.setFormValidations(this.state))
    const techDetailsErrors = run(
      this.state.techDetails.cg,
      this.setTechDetailsValidations(this.state)
    )

    currentState.validationErrors = { ...errors, ...techDetailsErrors }

    this.setState({ currentState })

    this.getSimilarityScoreTags(currentState.tags)

    if (updateItem) {
      this.updateItem(currentState)
    }

    this.onAllDataSet()
  }

  onAllDataSet() {
    this.setState({ isDataFetched: true })
  }

  validateAndUpdateState(newState, updateItem = false) {
    const errors = run(newState, this.setFormValidations(newState))
    const techDetailsErrors = run(
      newState.techDetails.cg,
      this.setTechDetailsValidations(newState)
    )

    newState.validationErrors = { ...errors, ...techDetailsErrors }

    this.setState(newState)
    this.debouncedFetchPublishingScore()

    if (updateItem) {
      this.debouncedUpdateItem(newState)
    }
  }

  debouncedFetchPublishingScore = debounce(300, this.fetchPublishingScore)

  showPaymentAgreementBlocker = (payload) => {
    if (!payload) {
      return
    }

    this.setState({
      disableActions: false,
      paymentAgreementBlocker: {
        isOpen: true,
        message: payload.message || '',
        ctaLabel: payload.cta_label || '',
        dismissLabel: payload.dismiss_label || '',
        ctaHref: payload.cta_href || '',
        showCta: payload.show_cta !== false,
      },
    })
  }

  closePaymentAgreementBlocker = () => {
    this.setState((prevState) => ({
      paymentAgreementBlocker: {
        ...prevState.paymentAgreementBlocker,
        isOpen: false,
      },
    }))
  }

  fetchPublishingScore() {
    if (this.state.id !== '') {
      const url = `/api/internal/items/${
        this.state.id
      }/publishing-score?nocache=${new Date().getTime()}`

      axios
        .get(url)
        .then((response) =>
          this.setState({ publishingScore: response.data.score })
        )
        .catch(() =>
          App.events.publish(
            'app:notification:flash:error',
            'Publishing score could not be counted'
          )
        )
    } else {
      return null
    }
  }

  onModalClose() {
    this.setState({ confirmationModalIsOpen: false })
  }

  onUseAsTemplateChange() {
    const newSate = update(this.state, {
      useAsTemplate: { $set: !this.state.useAsTemplate },
    })
    this.validateAndUpdateState(newSate, true)
  }

  onDrop(files, rejected) {
    const currentAttachments = []
    const imagesToUpload = []
    const imagesUploading = []
    let imagesErrorShown = false

    files.forEach((file) => {
      const extension = file.name.split('.').pop().toLowerCase()

      if (this.imagesExtensions.includes(extension)) {
        if (file.size > this.maxImageSize) {
          App.events.publish(
            'app:notification:flash:error',
            'Image is too large'
          )
          imagesErrorShown = true
        } else {
          imagesToUpload.push(file)
        }
      } else {
        currentAttachments.push(file)
      }
    })

    Object.values(this.state.attachments).forEach((attachment) => {
      if (
        attachment.isImage &&
        this.state.images.filter((image) => image.fileName === attachment.name)
          .length === 0
      ) {
        imagesUploading.push(attachment)
      }
    })

    let imagesCount = this.state.images.length + imagesUploading.length

    imagesToUpload.forEach((image) => {
      if (imagesCount < 150) {
        currentAttachments.push(image)
        imagesCount += 1
      } else if (!imagesErrorShown) {
        App.events.publish(
          'app:notification:flash:error',
          "You can't upload more than 150 images"
        )
        imagesErrorShown = true
      }
    })

    this.previousImages = this.state.images.slice(0)
    this.uploadingImages ? null : (this.uploadingImages = 0)

    const newAttachmentsState = this.state.attachments
    currentAttachments.forEach((file) => {
      const extension = file.name.split('.').pop().toLowerCase()

      newAttachmentsState[file.name] = {
        name: file.name,
        progress: 0,
        isImage: this.imagesExtensions.includes(extension),
      }
    })

    this.setState({
      attachments: update(this.state.attachments, {
        $merge: newAttachmentsState,
      }),
    })

    let uploads = 0

    const imageAttachments = []
    const fileAttachments = []

    currentAttachments.forEach((attachment) => {
      uploads += 1
      const extension = attachment.name.split('.').pop().toLowerCase()
      const uploadType = this.imagesExtensions.includes(extension)
        ? 'image'
        : 'file'

      if (uploadType === 'image') {
        imageAttachments.push(attachment)
      } else {
        fileAttachments.push(attachment)
      }
    })

    fileAttachments.forEach(async (file) => {
      const data = new FormData()
      data.append('filename', file.name)
      data.append('type', 'file')

      const checksum = await fileChecksum(file)

      if (checksum) data.append('checksum', checksum)

      axios
        .post(`/profile/items/${this.state.id}/uploads`, data)
        .then((response) => this.uploadToS3(file, response.data))
        .catch((error) => this.onUploadFailure(error, file))
    })

    const newImagesToUpload = []

    imageAttachments.forEach((image) => {
      const newImageObj = { [image.name]: image }
      newImagesToUpload.push(newImageObj)
    })

    this.setState((prevState) => ({
      uploadsInProgress: prevState.uploadsInProgress + uploads,
      disableActions: prevState.uploadsInProgress + uploads !== 0,
      imagesToUpload: [...prevState.imagesToUpload, ...newImagesToUpload],
      droppedImages: [...prevState.droppedImages, ...newImagesToUpload],
    }))
  }

  onUploadProgress(fileName, progressEvent, progress = 0) {

    let uploadProgress = progress

    if (progressEvent) {
      uploadProgress = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      )
    }

    this.setState((prevState) => ({
      attachments: update(prevState.attachments, {
        [fileName]: { $merge: { progress: uploadProgress } },
      }),
    }))
  }

  checkIfFormIsValid(state) {
    const unitsHaveError =
      state.type === 'printable' && state.techDetails.printable.units === null
    const adultImagesHaveError =
      state.images.length === 0
        ? false
        : state.isAdultContent &&
          state.images.filter((image) => image.isAdultContent === true)
            .length === 0
    const hasNoImagesOrFiles =
      this.state.images.length === 0 || this.state.files.length === 0
    const hasTooManyImages = this.state.images.length > 150
    const hasNoCategoryInfo =
      this.state.categoryId === null || this.state.subcategoryId === null

    if (
      state.tagHasError ||
      state.descriptionHasError ||
      unitsHaveError ||
      hasNoImagesOrFiles ||
      hasTooManyImages ||
      adultImagesHaveError ||
      hasNoCategoryInfo
    ) {
      return false
    }

    return Object.getOwnPropertyNames(state.validationErrors).length === 0
  }

  debouncedUpdateItem = debounce(5000, this.updateItem)

  updateItem(state, publish = false, disableActions = false, callback = null) {
    if (
      state.status === 'draft' ||
      (state.status !== 'draft' && publish) ||
      state.requiresForcedSave
    ) {
      if (this.checkIfFormIsValid(state) || !publish) {
        if (disableActions) {
          this.setState({ disableActions: true })
        }

        const itemData = {
          draft: state.status === 'draft',
          type: state.type,
          category_id: state.categoryId,
          sub_category_id: state.subcategoryId,
          adult_content: state.isAdultContent,
          free: state.isFree,
          isFree: state.isFree,
          description: state.description,
          license: state.license,
          tags: state.tags,
          image_ids: state.images.map((image) => image.id),
          embed_ids: state.embeds.map((embed) => embed.id),
          removed_image_ids: state.removedImageIds.map((id) => id),
          use_as_template: state.useAsTemplate,
          ai_generated: state.aiGenerated,
        }

        if (state.status === 'draft') {
          if (
            state.title.length < 255 &&
            state.validationErrors.title !==
              'Please use Latin alphabet and numbers only'
          ) {
            itemData.title = state.title
          }

          if (
            state.price === '' ||
            (state.price !== '' &&
              state.price >= 0 &&
              state.price < Number.MAX_SAFE_INTEGER)
          ) {
            itemData.price = state.price
          }

          if (
            state.validationErrors.customLicense !==
            'Custom license should not contain non-latin symbols'
          ) {
            itemData.custom_license = state.customLicense
          }
        } else {
          itemData.title = state.title
          itemData.price = state.price
          itemData.custom_license = state.customLicense
        }

        if (state.type === 'cg') {
          const cgTechDetails = state.techDetails.cg

          itemData.textures = cgTechDetails.textures
          itemData.materials = cgTechDetails.materials
          itemData.animated = cgTechDetails.animated
          itemData.rigged = cgTechDetails.rigged
          itemData.game_ready = cgTechDetails.gameReady
          itemData.pbr = cgTechDetails.pbr
          itemData.uvw_mapping = cgTechDetails.uvwMapping
          itemData.plugins_used = cgTechDetails.pluginsUsed
          itemData.unwrapped_uvs = cgTechDetails.unwrappedUvs
          itemData.geometry_type = cgTechDetails.geometryType

          if (state.status === 'draft') {
            if (
              cgTechDetails.polygons === '' ||
              (cgTechDetails.polygons !== '' &&
                cgTechDetails.polygons >= 0 &&
                cgTechDetails.polygons < Number.MAX_SAFE_INTEGER)
            ) {
              itemData.polygons = cgTechDetails.polygons
            }

            if (
              cgTechDetails.vertices === '' ||
              (cgTechDetails.vertices !== '' &&
                cgTechDetails.vertices >= 0 &&
                cgTechDetails.vertices < Number.MAX_SAFE_INTEGER)
            ) {
              itemData.vertices = cgTechDetails.vertices
            }
          } else {
            itemData.polygons = cgTechDetails.polygons
            itemData.vertices = cgTechDetails.vertices
          }
        } else if (state.type === 'printable') {
          itemData.units = state.techDetails.printable.units
          itemData.is_pre_supported = state.techDetails.printable.isPreSupported
          itemData.is_split_into_multiple_parts = state.techDetails.printable.isSplitIntoMultipleParts
          itemData.multiple_parts_details = state.techDetails.printable.multiplePartsDetails
        }

        this.setState({ requiresForcedSave: false })

        axios
          .patch(`/profile/items/${state.id}`, {
            item: itemData,
            dont_validate: !publish,
          })
          .then(() => this.onUpdateSuccess(publish, callback))
          .catch(() => this.onPublishFailure(callback))
      } else {
        if (publish) {
          App.events.publish(
            'app:notification:flash:error',
            'Not all details are entered, please take another look'
          )

          if (state.images.length > 150) {
            App.events.publish(
              'app:notification:flash:error',
              "Item can't have more than 150 images"
            )
          }
        }

        return null
      }
    } else {
      return null
    }
  }

  onUpdateSuccess(publish, callback) {
    if (publish) {
      this.publishItem()
    }

    if (callback) {
      callback()
    }
  }

  publishItem() {
    const publishUrl = this.state.status === 'draft' ? 'publish' : 'republish'

    axios
      .post(`/profile/items/${this.state.id}/${publishUrl}`, {
        item: {
          tags: this.state.tags,
        },
      })
      .then(this.onPublishSuccess)
      .catch(this.onPublishFailure)
  }

  onPublishSuccess(response) {
    const isDraft = this.state.status === 'draft'
    const href = isDraft
      ? response.data.isFirstUpload
        ? '/profile/models?first_time=1'
        : '/profile/models'
      : this.state.itemLink

    App.events.publish(
      'app:notification:flash:success',
      `Item was successfully ${isDraft ? 'published' : 'updated'}`
    )

    window.customEventTracker({
      name: 'upload_content',
      userId: App.config.userId || '',
      eventData: this.getTrackingData(),
    })

    window.location.href = href
  }

  onPublishFailure(errorOrCallback) {
    const axiosError = errorOrCallback && errorOrCallback.response

    if (axiosError) {
      const { data } = errorOrCallback.response

      if (data?.error_code === 'payment_agreement_verification_required') {
        this.showPaymentAgreementBlocker(data)
        return
      }

      if (data?.error_message) {
        this.setState({ disableActions: false })
        App.events.publish(
          'app:notification:flash:error',
          data.error_message
        )
        return
      }
    }

    this.setState({ disableActions: false })
    App.events.publish(
      'app:notification:flash:error',
      'Something went wrong, please try again'
    )
  }

  handleFormSubmit(e) {
    e.preventDefault()

    this.setState({ showErrors: true })

    this.debouncedUpdateItem(this.state, true, true)
  }

  onDeleteDraftClick() {
    this.setState({ confirmationModalIsOpen: true })
  }

  errorFor(field) {
    return this.state.validationErrors[field] || ''
  }

  handleDetailChange(label, value) {
    const newState = update(this.state, { [label]: { $set: value } })

    if (label === 'categoryId') {
      const { categories } = this.state
      const subcategories = categories.find((category) => category.id === value)?.subcategories || []

      newState.subcategoryId = subcategories.length === 1 ? subcategories[0].id : null
    }

    if (label === 'isAdultContent') {
      newState.requiresForcedSave = true

      if (!value) {
        this.resetAdultImages()
      } else {
        this.setAdultImages()
      }
    }

    this.validateAndUpdateState(newState, true)
  }

  resetAdultImages() {
    const adultImages = this.state.images.filter(
      (image) => image.isAdultContent === true
    )

    adultImages.forEach((adultImage) => {
      const imageId = adultImage.id
      const isAdultImage = false

      this.putImage(imageId, false)
    })
  }

  setAdultImages() {
    this.state.images.forEach((image, i) => {
      const imageId = image.id

      this.putImage(imageId, true)
    })
  }

  putImage(imageId, isAdultImage) {
    axios
      .put(`/api/internal/items/${this.state.id}/images/${imageId}`, {
        adult_content: isAdultImage,
      })
      .then(() => this.updateImageAdultAttr(imageId, isAdultImage))
      .catch(() =>
        App.events.publish(
          'app:notification:flash:error',
          'Adult marking failed'
        )
      )
  }

  updateTechDetails(label, value) {
    const newState = update(this.state, {
      techDetails: { [this.state.type]: { [label]: { $set: value } } },
    })

    if (label === 'uvwMapping') {
      newState.techDetails.cg.unwrappedUvs = value ? 'unknown' : null
    }

    this.validateAndUpdateState(newState, true)
  }

  updateMultipleTechDetails(updates) {
    if (!updates || typeof updates !== 'object') {
      return
    }

    const updateSpec = Object.keys(updates).reduce((acc, key) => ({
      ...acc,
      [key]: { $set: updates[key] },
    }), {})

    const newState = update(this.state, {
      techDetails: { [this.state.type]: updateSpec },
    })

    this.validateAndUpdateState(newState)
  }

  checkMqsValidity(itemFileId, fileData, fileSize) {
    axios
      .post(
        `/api/internal/items/${this.state.id}/item_files/${itemFileId}/validate_mqs`,
        { file_data: fileData, file_size: fileSize }
      )
      .then((response) => {
        const data = response.data.data
        const cgTechDetails = this.state.techDetails.cg

        if (Object.keys(data).length === 0) {
          return null
        }

        const newState = update(this.state, {
          title: {
            $set:
              typeof data.title === 'undefined' ? this.state.title : data.title,
          },
          techDetails: {
            cg: {
              textures: {
                $set:
                  typeof data.info.textures === 'undefined'
                    ? cgTechDetails.textures
                    : data.info.textures,
              },
              materials: {
                $set:
                  typeof data.info.materials === 'undefined'
                    ? cgTechDetails.materials
                    : data.info.materials,
              },
              animated: {
                $set:
                  typeof data.animated === 'undefined'
                    ? cgTechDetails.animated
                    : data.animated,
              },
              rigged: {
                $set:
                  typeof data.rigged === 'undefined'
                    ? cgTechDetails.rigged
                    : data.rigged,
              },
              gameReady: {
                $set:
                  typeof data.gameReady === 'undefined'
                    ? cgTechDetails.gameReady
                    : data.gameReady,
              },
              uvwMapping: {
                $set:
                  typeof data.info.uvwMapping === 'undefined'
                    ? cgTechDetails.uvwMapping
                    : data.info.uvwMapping,
              },
              unwrappedUvs: {
                $set:
                  typeof data.info.unwrappedUvs === 'undefined'
                    ? cgTechDetails.unwrappedUvs
                    : data.info.unwrappedUvs,
              },
              pluginsUsed: {
                $set:
                  typeof data.info.pluginsUsed === 'undefined'
                    ? cgTechDetails.pluginsUsed
                    : data.info.pluginsUsed,
              },
              geometryType: {
                $set:
                  typeof data.info.geometryType === 'undefined'
                    ? cgTechDetails.geometryType
                    : data.info.geometryType,
              },
              polygons: {
                $set:
                  typeof data.info.polygons === 'undefined'
                    ? cgTechDetails.polygons
                    : data.info.polygons,
              },
              vertices: {
                $set:
                  typeof data.info.vertices === 'undefined'
                    ? cgTechDetails.vertices
                    : data.info.vertices,
              },
            },
          },
        })
        this.validateAndUpdateState(newState)

        App.events.publish(
          'app:notification:flash:success',
          'MQS validation successful'
        )
      })
      .catch(() =>
        App.events.publish(
          'app:notification:flash:error',
          'MQS validation failed'
        )
      )
  }

  handleInputChange(e) {
    const newState = update(this.state, {
      [e.target.id]: { $set: e.target.value },
    })
    this.validateAndUpdateState(newState)
  }

  handleInputBlur() {
    this.debouncedUpdateItem(this.state)
  }

  handlePreview(event) {
    event.preventDefault()

    this.updateItem(
      this.state,
      false,
      false,
      () => (window.location = `/preview-3d-model/${this.state.id}`)
    )

    return false
  }

  handleEditorChange(value, hasError) {
    const newState = update(this.state, {
      description: { $set: value },
      descriptionHasError: { $set: hasError },
    })
    this.validateAndUpdateState(newState)
  }

  onTagsChange(tags, hasError) {
    const lastTag = tags[tags.length - 1]
    if (lastTag) {
      const normalizedTag = lastTag.toLowerCase().replace(/\s+/g, '-')
      const isRestricted = restrictedTags.includes(normalizedTag) || prohibitedSoftwareTags.includes(normalizedTag)
      const isIgnored = ignoredTags.includes(lastTag)

      if (isRestricted) {
        App.events.publish(
          'app:notification:flash:error',
          "This tag can't be used. Please enter a different one"
        )
      }

      if (isRestricted || isIgnored) {
        tags.splice(-1, 1)
      }
    }

    const newState = update(this.state, {
      tags: { $set: tags },
      tagHasError: { $set: hasError },
    })
    this.validateAndUpdateState(newState, true)
    this.getSimilarityScoreTags(tags)
  }

  onTypeChange(type) {
    const newState = update(this.state, {
      type: { $set: type },
      categoryId: { $set: null },
      subcategoryId: { $set: null },
    })

    this.validateAndUpdateState(newState, true)
  }

  addEmbed(url, fileId, fileName) {
    return axios
      .post(`/api/internal/items/${this.state.id}/embeds`, {
        embed: { url, item_file_id: fileId, item_file_name: fileName },
      })
      .then((response) => {
        this.onAddedEmbed(response.data.data.attributes, fileName)
      })
      .catch((xhr) => {
        App.events.publish(
          'app:notification:flash:error',
          xhr.response.statusText
        )
      })
  }

  deleteEmbed(id) {
    return axios
      .delete(`/api/internal/items/${this.state.id}/embeds/${id}`, {})
      .then((response) => {
        this.onDeletedEmbed(id)
      })
      .catch((xhr) => {
        App.events.publish(
          'app:notification:flash:error',
          xhr.response.statusText
        )
      })
  }

  onAddedEmbed(embed, fileName) {
    const newAttachmentsState = this.state.attachments
    delete newAttachmentsState[fileName]

    this.setState((prevState) => ({
      embeds: prevState.embeds.concat(embed),
      attachments: newAttachmentsState,
    }))
  }

  onEmbedsChange(embeds) {
    const newState = update(this.state, { embeds: { $set: embeds } })

    this.validateAndUpdateState(newState, true)
  }

  onViewerGenerated(embedData) {
    const newEmbed = {
      id: Number(embedData.id),
      image: embedData.image,
      title: embedData.title,
      position: embedData.position,
      type: embedData.type,
      externalId: embedData.external_id,
    }

    this.setState((prevState) => ({
      embeds: prevState.embeds.concat(newEmbed),
    }))

    App.events.publish(
      'app:notification:flash:success',
      '3D viewer generated successfully'
    )
  }

  onDeletedEmbed(id) {
    this.setState((prevState) => {
      const newAttachmentsState = prevState.attachments
      const removedEmbed = prevState.embeds.find((embed) => embed.id === id)

      if (removedEmbed) {
        delete newAttachmentsState[removedEmbed.title]
      }

      return {
        attachments: update(this.state.attachments, {
          $set: newAttachmentsState,
        }),
        embeds: prevState.embeds.filter((embed) => embed.id !== id),
      }
    })
  }

  onFreeModelTrigger() {
    const { isFree, license } = this.state
    const shouldBeFree = !isFree
    const freeLicenseOptions = I18n.translate('publisher.licenses_free').map(
      ({ value }) => value
    )
    const paydLicenseOptions = I18n.translate('publisher.licenses_paid').map(
      ({ value }) => value
    )

    let newLicense = license

    if (shouldBeFree && !freeLicenseOptions.includes(license)) {
      newLicense = freeLicenseOptions[0]
    }

    if (!shouldBeFree && license === 'royalty_free_no_ai') {
      newLicense = paydLicenseOptions[0]
    }

    const newState = update(this.state, {
      price: { $set: 0 },
      isFree: { $set: shouldBeFree },
      license: { $set: newLicense },
    })

    this.validateAndUpdateState(newState, true)
  }

  onAiGeneratedToggle() {
    const newState = update(this.state, {
      aiGenerated: { $set: !this.state.aiGenerated },
    })

    newState.detailsChanged = true

    this.validateAndUpdateState(newState, true)
  }

  onImageUploadFinish(blobId, fileAttributes) {
    const newAttachmentsState = this.state.attachments

    Object.values(this.state.attachments).forEach((attachment) => {
      if (attachment.name === fileAttributes.fileName) {
        newAttachmentsState[attachment.name] = {
          name: attachment.name,
          progress: attachment.progress,
          isProcessing: true,
          isImage: true,
        }
      }
    })

    this.setState({
      attachments: update(this.state.attachments, {
        $merge: newAttachmentsState,
      }),
    })

    let isLastImage = false

    this.setState(
      (prevState) => {
        const imagesLeftToUpload = prevState.imagesToUpload.filter(
          (image) => Object.keys(image)[0] !== fileAttributes.fileName
        )
        isLastImage = imagesLeftToUpload.length === 0

        return {
          images: prevState.images.concat({
            id: `${fileAttributes.id}`,
            url: fileAttributes.largeUrl,
            fileName: fileAttributes.fileName,
            isAdultContent: fileAttributes.adultContent,
            blobId,
          }),
          uploadsInProgress: prevState.uploadsInProgress - 1,
          disableActions: prevState.uploadsInProgress !== 1,
          imagesToUpload: imagesLeftToUpload,
        }
      },
      () => {
        if (isLastImage) {
          this.sortImages()
        }
      }
    )
  }

  onUploadFailure(error, file) {
    const browser = detect()
    let message = ''

    window.sendErrorToSentry(error, {
      tags: { section: 'ModelPublisher' },
      extra: {
        msg: 'Failed to upload file',
        fileName: file.name,
        fileSize: file.size,
        username: this.state.userData.username,
        sessionIp: this.state.userData.lastIpAddress,
      },
    })

    this.setState((prevState) => ({
      uploadsInProgress: prevState.uploadsInProgress - 1,
      disableActions: prevState.uploadsInProgress !== 1,
    }))

    switch (browser && browser.name) {
      case 'ie':
        message = `Upload failed. You are using Internet Explorer v${browser.version} - please try another browser.`
        break
      case 'edge':
        message = `Upload failed. You are using Edge v${browser.version} - please try another browser.`
        break
      default:
        message = 'Upload failed. Please try again or contact support'
    }

    if (error) {
      message += error.message
    }

    App.events.publish('app:notification:flash:error', message)
  }

  uploadToS3(file, token) {
    const bodyFormData = new FormData()

    Object.keys(token.storage).map((storageKey) => {
      bodyFormData.set(storageKey, token.storage[storageKey])
    })

    file.key = token.storage.key

    bodyFormData.set('key', file.key)
    bodyFormData.set('file', file)

    delete axios.defaults.headers.common['X-Requested-With']
    axios
      .post(token.storageLocation, bodyFormData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: this.onUploadProgress.bind(this, file.name),
      })
      .then((response) => this.onS3FileUpload(file, token, response))
      .catch((error) => this.onUploadFailure(error, file))
    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
  }

  onS3FileUpload(file, token, response) {
    const extension = file.name.split('.').pop().toLowerCase()

    if (extension === 'mtl') {
      this.updateTechDetails('materials', true)
    }

    axios
      .put(
        `/api/internal/items/${this.state.id}/item_files/${token.id}`,
        { key: file.key, filename: file.name, filesize: file.size },
        {}
      )
      .then((response) => {
        const newAttachmentsState = this.state.attachments
        const itemFileExtension = response.data.data.attributes.fileName
          .split('.')
          .pop()
          .toLowerCase()

        Object.values(this.state.attachments).forEach((attachment) => {
          if (attachment.name === file.name) {
            newAttachmentsState[attachment.name] = {
              name: attachment.name,
              progress: attachment.progress,
              isProcessing: true,
              isImage: false,
            }
          }
        })

        if (extension === 'mview') {
          this.addEmbed(
            `http://marmoset.com/${response.data.data.id}`,
            response.data.data.id,
            file.name
          )
        }

        this.setState({
          attachments: update(this.state.attachments, {
            $merge: newAttachmentsState,
          }),
        })

        if (itemFileExtension === 'mview') {
          this.setState((prevState) => ({
            uploadsInProgress: prevState.uploadsInProgress - 1,
            disableActions: prevState.uploadsInProgress !== 1,
          }))
        } else {
          this.setState((prevState) => ({
            files: prevState.files.concat({
              id: response.data.data.id,
              name: response.data.data.attributes.fileName,
              archive: response.data.data.attributes.archive,
              processed: response.data.data.attributes.processed,
              itemFileInfos: [
                {
                  id: response.data.included[0].id,
                  attributes: response.data.included[0].attributes,
                },
              ],
              contents: [],
            }),
            uploadsInProgress: prevState.uploadsInProgress - 1,
            disableActions: prevState.uploadsInProgress !== 1,
          }))
        }

        if (extension === 'zip') {
          const zip = new JSZip()
          zip
            .loadAsync(file)
            .then((zip) => this.readZipContent(zip, response.data.data.id))
        }

        if (
          itemFileExtension === 'zip' &&
          response.data.data.attributes.fileName.includes('_mqs') &&
          this.props.participatesInMqs
        ) {
          const maxSize = 64000
          let blob = file
          const reader = new FileReader()
          const _this = this

          if (file.size > maxSize) {
            blob = file.slice(file.size - maxSize, file.size)
          }

          reader.onloadend = () => {
            const result = Array.from(new Uint8Array(reader.result))
              .map((b) => b.toString(16).padStart(2, '0'))
              .join('')

            _this.checkMqsValidity(response.data.data.id, result, file.size)
          }

          reader.readAsArrayBuffer(blob)
        }
      })
      .catch((error) => this.onUploadFailure(error, file))
  }

  readZipContent(zip, fileId) {
    const contents = []
    const fileToUpdate = this.state.files.find((file) => file.id === fileId)
    const fileIndex = this.state.files.indexOf(fileToUpdate)

    zip.forEach((relativePath, zipEntry) => {
      contents.push(zipEntry.name)
    })

    this.setState({
      files: update(this.state.files, {
        [fileIndex]: { contents: { $set: contents } },
      }),
    })
  }

  getSimilarityScoreTags(tags) {
    const recommendedTags = []
    if (recommendedTags.length <= 9 && tags.length >= 1) {
      const url = `/api/internal/tags/suggest?nocache=${new Date().getTime()}`

      axios
        .get(url, {
          params: { tags, existing_tags: recommendedTags },
        })
        .then((response) =>
          this.onSimilarityScoreTags(response, recommendedTags)
        )
        .catch((error) => {})
    }
  }

  onSimilarityScoreTags(response, oldRecommendedTags) {
    const recommendedTags = oldRecommendedTags.concat(
      response.data
        .filter(
          (tag) =>
            !this.state.tags.includes(tag.tag) &&
            !oldRecommendedTags.includes(tag.tag)
        )
        .map((tag) => tag.tag)
    )

    this.setState({ recommendedTags: recommendedTags.slice(0, 10) })
  }

  adjustAttachments(files, removedTitle) {
    const newAttachmentsState = this.state.attachments
    if (removedTitle) {
      delete newAttachmentsState[removedTitle]
    }

    const newState = update(this.state, {
      files: { $set: files },
      attachments: { $set: newAttachmentsState },
    })

    this.validateAndUpdateState(newState)
  }

  onFilesChange(files, updatedFileInfo, removedTitle) {
    if (files.length < this.state.files.length) {
      this.adjustAttachments(files, removedTitle)
    } else {
      const newState = update(this.state, { files: { $set: files } })

      this.validateAndUpdateState(newState)
    }

    if (!updatedFileInfo) {
      return
    }

    const fileType = this.state.fileTypes.find(
      (fileType) => fileType.id === updatedFileInfo.attributes.fileTypeId
    )
    const renderer = fileType.renderers.find(
      (renderer) => renderer.id === updatedFileInfo.attributes.rendererId
    )

    if (renderer && !renderer.default) {
      this.updateTechDetails('pluginsUsed', true)
    }

    if (
      fileType.title === 'Textures' ||
      fileType.title === 'Additional Textures'
    ) {
      this.updateTechDetails('textures', true)
    }

    if (fileType.title === 'Alias/WaveFront Material (.mtl)') {
      this.updateTechDetails('materials', true)
    }
  }

  updateImageAdultAttr(id, isAdult) {
    const currentImages = this.state.images

    const imageToUpdateIndex = currentImages.findIndex(
      (image) => image.id === id
    )
    const updatedImage = update(currentImages[imageToUpdateIndex], {
      isAdultContent: { $set: isAdult },
    })
    const newImages = update(currentImages, {
      $splice: [[imageToUpdateIndex, 1, updatedImage]],
    })

    if (isAdult) {
      this.setState({ requiresForcedSave: true })

      if (!this.state.isAdultContent) {
        this.setState({ isAdultContent: true })
      }
    }

    this.onImagesChange(newImages, this.state.removedImageIds)
  }

  onChooseDraftModel(id) {
    this.fetchItemData(id)
  }

  onImagesChange(images, removedImageIds) {
    const newAttachmentsState = this.state.attachments
    const adultImages = images.filter((image) => image.isAdultContent === true)

    if (images < this.state.images) {
      const removedTitles = []

      removedImageIds.forEach((removedId) => {
        const removedImage = this.state.images.find(
          (image) => image.id === removedId
        )
        if (removedImage) {
          removedTitles.push(removedImage.fileName)
        }
      })

      removedTitles.forEach((title) => {
        delete newAttachmentsState[title]
      })
    }

    const newState = update(this.state, {
      images: { $set: images },
      removedImageIds: { $set: removedImageIds },
      attachments: { $set: newAttachmentsState },
    })

    if (images.length === 0) {
      newState.isAdultContent = false
    }

    if (adultImages.length === 0 && newState.isAdultContent) {
      newState.isAdultContent = false
      newState.requiresForcedSave = true
    }

    this.validateAndUpdateState(newState, true)
  }

  sortImages() {
    const imagesDragged =
      this.previousImages.map((image) => image.id).join(',') !==
      this.previousImages
        .slice(0)
        .sort((a, b) => {
          return a.fileName < b.fileName ? -1 : a.fileName > b.fileName ? 1 : 0
        })
        .map((image) => image.id)
        .join(',')
    if (this.previousImages.length >= 1 && imagesDragged) {
      return
    }

    this.state.images.sort((a, b) => {
      return a.fileName < b.fileName ? -1 : a.fileName > b.fileName ? 1 : 0
    })
    this.setState((prevState) => ({
      images: prevState.images.concat({
        id: '',
        url: '',
        fileName: '',
        isAdultContent: false,
      }),
    }))
    this.setState((prevState) => {
      prevState.images.pop()
      return {
        images: prevState.images,
        sortVersion: prevState.sortVersion + 1,
      }
    })
    axios
      .patch(`/profile/items/${this.state.id}`, {
        item: { image_ids: this.state.images.map((image) => image.id) },
        dont_validate: true,
      })
      .catch((error) => {})
  }

  disableMainDropZone(isDisabled) {
    this.setState({ disableDropZone: isDisabled })
  }

  renderPublishingScore(score) {
    return (
      <PublishingScore
        key={score}
        publishingScore={score}
        type={this.state.type}
        tagsLength={this.state.tags.length}
        descriptionLength={this.state.description.split(' ').length}
        imagesLength={this.state.images.length}
        embedsLength={this.state.embeds.length}
        files={this.state.files}
      />
    )
  }

  handleCloseNotice() {
    Cookies.set('kodama_notice_set', true)

    this.setState({ kodamaNoticeClosed: true })
  }

  parsePrice(number) {
    const temp = parseFloat(number).toFixed(2)

    return parseFloat(temp)
  }

  getTrackingData() {
    const { categoryId, categories, subcategoryId, tags, price, fileTypes } =
      this.state

    if (categoryId && subcategoryId) {
      const currentCategory = categories.find(
        (category) => category.id === categoryId
      )
      const { title, subcategories } = currentCategory || {}

      const currentSubcategory = subcategories.find(
        (subcategory) => subcategory.id === subcategoryId
      )
      const { title: subcategoryTitle } = currentSubcategory || {}

      const currentTags = tags.join('_')
      const parsedPrice = this.parsePrice(price)
      const currentFileTypeIds = this.getCurrentFileTypes()

      const currentFileTypes = fileTypes
        .filter((fileType) => currentFileTypeIds.includes(fileType.id))
        .map(({ extensions, title: fileTypeTitle }) => {
          return extensions.length ? extensions.join('_') : fileTypeTitle
        })
        .join('_')

      return {
        content_type: 'model',
        content_category: title,
        content_tags: currentTags,
        file_format: currentFileTypes,
        content_subcategory: subcategoryTitle,
        model_price: parsedPrice,
      }
    }

    return null
  }

  getCurrentFileTypes() {
    const { files } = this.state
    const currentFileTypeInfos = files.reduce(
      (acc, { itemFileInfos }) => [...acc, ...itemFileInfos],
      []
    )
    const currentFileTypes = currentFileTypeInfos.map(
      ({ attributes }) => attributes.fileTypeId
    )

    return currentFileTypes
  }

  renderPaymentAgreementBlocker() {
    const { paymentAgreementBlocker } = this.state

    if (!paymentAgreementBlocker?.isOpen) {
      return null
    }

    const fallbackMessage = I18n.translate('publisher.payment_agreement_blocker.message')
    const fallbackCta = I18n.translate('publisher.payment_agreement_blocker.cta')
    const fallbackDismiss = I18n.translate('publisher.payment_agreement_blocker.dismiss')
    const message = paymentAgreementBlocker.message || fallbackMessage
    const ctaLabel = paymentAgreementBlocker.ctaLabel || fallbackCta
    const dismissLabel = paymentAgreementBlocker.dismissLabel || fallbackDismiss
    const ctaHref = paymentAgreementBlocker.ctaHref || '/profile/hyperwallet-account'
    const showCta = paymentAgreementBlocker.showCta !== false

    return (
      <div className="publishing-actions__popover">
        <button
          type="button"
          className="publishing-actions__popover-close"
          onClick={this.closePaymentAgreementBlocker}
          aria-label="Close payment agreement notice"
        >
          <Icon type={['fas', 'times']} />
        </button>
        <p
          className="publishing-actions__popover-message"
          dangerouslySetInnerHTML={{ __html: message }}
        />
        <div className="publishing-actions__popover-actions">
          {showCta && (
            <a
              href={ctaHref}
              className="btn btn-primary"
              target="_blank"
              rel="noopener noreferrer"
            >
              {ctaLabel}
            </a>
          )}
          <button
            type="button"
            className="btn btn-white btn-outline-default"
            onClick={this.closePaymentAgreementBlocker}
          >
            {dismissLabel}
          </button>
        </div>
      </div>
    )
  }

  render() {
    const { cadProductTypeEnabled } = this.props

    return this.state.isDataFetched ? (
      <form onSubmit={this.handleFormSubmit}>
        <Dropzone
          disableClick
          className="drop-area--full-screen"
          getDataTransferItems={(event) =>
            getDroppedOrSelectedFiles(event).then((list) =>
              list.map(({ fileObject, ...rest }) => fileObject)
            )
          }
          onDrop={this.onDrop}
          disabled={this.state.disableDropZone}
        >
          {!this.state.disableDropZone && this.state.dropzoneActive && (
            <DropzoneOverlay />
          )}
          <UploadArea
            ref={this.uploadAreaRef}
            modelId={this.state.id}
            onDrop={this.onDrop}
            onDraftChoose={this.onChooseDraftModel}
            otherDraftsCount={
              this.props.isEditingMode ? 0 : this.state.otherDraftsCount
            }
            isImageUploadMode={this.state.isImageUploadMode}
            onFileDialogClose={this.handleFileDialogClose}
          />

          {Object.values(this.state.attachments).map((attachment, index) => {
            if (attachment.progress === 100) return null

            return (
              <UploadProgress
                fileName={attachment.name}
                progress={attachment.progress}
                isProcessing={false}
                key={index}
              />
            )
          })}
        </Dropzone>

        {!this.state.kodamaNoticeClosed && (
          <KodamaNotice onClose={this.handleCloseNotice} />
        )}

        <FilesArea
          itemId={this.state.id}
          itemStatus={this.state.status}
          files={this.state.files}
          fileTypes={this.state.fileTypes}
          showErrors={this.state.showErrors}
          onChange={this.onFilesChange}
        />
        <DirectUploadImages
          modelId={this.state.id}
          files={this.state.droppedImages.map((img) => Object.values(img)[0])}
          onFileUploadFinish={this.onImageUploadFinish}
          onUploadFailure={this.onUploadFailure}
          onUploadProgress={this.onUploadProgress}
          clearFiles={() => this.setState({ droppedImages: [] })}
        />
        <ImagesArea
          itemId={this.state.id}
          itemStatus={this.state.status}
          images={this.state.images}
          sortVersion={this.state.sortVersion}
          removedImageIds={this.state.removedImageIds}
          isAdultContent={this.state.isAdultContent}
          showErrors={this.state.showErrors}
          handleDetailChange={this.handleDetailChange}
          updateImageAdultAttr={this.updateImageAdultAttr}
          onChange={this.onImagesChange}
          onDragStateChange={({ isActive }) =>
            this.setState({ disableDropZone: isActive })
          }
          parentalLocked={this.state.parentalLocked}
          onUploadClick={this.handleImageUploadClick}
        />
        <EmbedsArea
          addEmbed={this.addEmbed}
          embeds={this.state.embeds}
          deleteEmbed={this.deleteEmbed}
          onDrop={this.onDrop}
          onChange={this.onEmbedsChange}
          disableMainDropZone={this.disableMainDropZone}
          onDragStateChange={({ isActive }) =>
            this.setState({ disableDropZone: isActive })
          }
          itemId={this.state.id ? Number(this.state.id) : null}
          hasSupportedFileTypes={hasSupportedFileTypesForViewer(this.state.files, this.state.fileTypes)}
          onViewerGenerated={this.onViewerGenerated}
        />
        <DetailsArea
          isPrintable={this.state.type === 'printable'}
          isLowPoly={this.state.techDetails.cg.gameReady}
          title={this.state.title}
          description={this.state.initialDescription}
          tags={this.state.tags}
          tagsInputRef={this.tagsInputRef}
          recommendedTags={[]}
          showTagsTip={this.state.images.length === 0}
          showErrors={this.state.showErrors}
          onTagsChange={this.onTagsChange}
          handleInputChange={this.handleInputChange}
          handleInputBlur={this.handleInputBlur}
          handleEditorChange={this.handleEditorChange}
          errorFor={this.errorFor}
        />
        <ChallengesArea
          challenges={this.state.type === 'cad' ? [] : this.state.challenges}
          tags={this.state.tags}
          onTagsChange={this.onTagsChange}
          isPrintable={this.state.type === 'printable'}
          isFree={this.state.isFree}
        />
        <TechnicalDetailsArea
          onDetailsChange={this.updateTechDetails}
          onMultipleDetailsChange={this.updateMultipleTechDetails}
          onTypeChange={this.onTypeChange}
          type={this.state.type}
          cgTechDetails={this.state.techDetails.cg}
          printableTechDetails={this.state.techDetails.printable}
          showErrors={this.state.showErrors}
          errorFor={this.errorFor}
          aiGenerated={this.state.aiGenerated}
          onAiGeneratedToggle={this.onAiGeneratedToggle}
          cadProductTypeEnabled={cadProductTypeEnabled}
        />
        <CategoryArea
          categoryId={this.state.categoryId}
          subcategoryId={this.state.subcategoryId}
          categories={this.state.categories.filter(
            (category) => category.productType === this.state.type
          )}
          handleDetailChange={this.handleDetailChange}
          showErrors={this.state.showErrors}
        />
        <PricingAndLicenseArea
          handleInputChange={this.handleInputChange}
          handleInputBlur={this.handleInputBlur}
          errorFor={this.errorFor}
          handleDetailChange={this.handleDetailChange}
          onFreeModelTrigger={this.onFreeModelTrigger}
          price={this.state.price || undefined}
          isFree={this.state.isFree}
          license={this.state.license}
          customLicense={this.state.customLicense}
          showErrors={this.state.showErrors}
        />
        <StickyFooterActions className="form-footer__wrapper">
          {!!this.props.onViewToggle && (
            <div
              className='cgt-tag cgt-legacy-back-color-grey-60 cgt-legacy-color-white-100 cgt-tag--clickable new-view-button'
              onClick={this.props.onViewToggle}
            >
              <span className="cgt-tag__text">New View</span>
            </div>
          )}

          <div className="form-footer">
            {this.renderPublishingScore(this.state.publishingScore)}

            <div className="publish-actions u-text-right">
              <div className="publishing-notification">
                <div className="card publishing-notification__card">
                  <div className="l-inner">
                    <div className="publishing-notification__text">
                      <Icon
                        type={['fas', 'exclamation-circle']}
                        color="green"
                        className="ml-5 publishing-notification__icon"
                      />
                      <p>
                        {
                          'Please note: Uploading the content you do not own is a serious breach of our '
                        }
                        <a
                          href="https://www.cgtrader.com/pages/terms-and-conditions"
                          target="_blank"
                          rel="nofollow noreferrer"
                        >
                          Terms and Conditions
                        </a>
                        {
                          ' and might result in a listing removal and account suspension.'
                        }
                      </p>
                    </div>

                    <div className="publishing-actions__container">
                      <div
                        className={`publishing-actions__checkbox
                          publishing-actions__checkbox--template-model
                          template-section__free-check`}
                      >
                        <input
                          type="checkbox"
                          id="template-model"
                          className="checkbox"
                          checked={this.state.useAsTemplate}
                          onChange={this.onUseAsTemplateChange}
                        />
                        <label htmlFor="template-model">
                          Keep the same settings for further model uploads
                        </label>
                      </div>
                      <div className="publishing-actions__buttons">
                        {this.renderPaymentAgreementBlocker()}
                        {this.state.status === 'draft' && (
                          <Fragment>
                            <button
                              type="button"
                              className="btn btn-white btn-outline-default btn-fat"
                              disabled={this.state.disableActions}
                              onClick={this.onDeleteDraftClick}
                            >
                              Delete draft
                            </button>

                            <DeleteConfirmationModal
                              modalIsOpen={this.state.confirmationModalIsOpen}
                              modelId={this.state.id}
                              closeModal={this.onModalClose}
                            />

                            <span className="separator" />
                            <button
                              onClick={this.handlePreview}
                              className={`btn btn-white btn-outline-default btn-fat ${
                                this.state.disableActions ? 'is-disabled' : ''
                              }`}
                            >
                              Preview
                            </button>
                          </Fragment>
                        )}
                        <button
                          type="submit"
                          className="btn btn-fat btn-primary u-ml10"
                          disabled={this.state.disableActions}
                        >
                          {this.state.status === 'draft' ? 'Publish' : 'Save'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </StickyFooterActions>
      </form>
    ) : (
      <Loader />
    )
  }
}

ModelPublisher.propTypes = {
  modelId: PropTypes.string,
  isEditingMode: PropTypes.bool.isRequired,
  participatesInMqs: PropTypes.bool.isRequired,
  onViewToggle: PropTypes.func,
  cadProductTypeEnabled: PropTypes.bool,
}

ModelPublisher.defaultProps = {
  modelId: '',
  onViewToggle: undefined,
  cadProductTypeEnabled: false,
}

export default ModelPublisher
